export { Icons30 } from "./Icons30";
